<template>
    <div class="root">
        <header>Account Deletion Policy</header>
        <p>
            [Special Note] Dear users, before you start the next step [Haba] account cancellation process, we would
            like to make the following special instructions for you: [Haba] will cease to provide this account with
            our high-quality and diversified products and services, which will inevitably bring inconvenience to your
            after-sales rights protection. Once your [Haba] account is canceled, it cannot be restored. Please
            consider carefully before the cancellation.
        </p>
        <p>
            If you still decide to cancel your [Haba] account after careful consideration, please read carefully and
            fully understand this [Haba] Account Cancellation Policy . After accepting all its content, please
            proceed with the next step according to our operation guidelines for cancellation.
            <b>
                . By starting a cancellation through the cancellation method provided in Part 3 of this policy, you are
                deemed to have accepted to sign and abide by the entire content of this policy.
            </b>
            If you need to use our services again after the cancellation, you are welcome to re-register using your
            mobile phone number or other methods allowed by [Haba]. At the same time, we also want to know about your
            experience with our products/services, and you can contact us by email to [
            <span style="color: blue;">report@habagogo.com]</span>
            , so that we can further improve and perfect our products and services.
        </p>
        <p>
            (If you still decide to cancel your [Haba] account, please continue to read below) I.Please note: account
            cancellation will have the following effects on you:
        </p>
        <p>
            1.Once your [Haba] account is canceled, you will not be able to log in to or use this account (including
            using this account as a third-party account to log in to other products), that is, you will not be able to
            log in/use/continue to use related products and services of [Haba] through this account;
        </p>
        <p>
            2.Once your [Haba] account is canceled, all content, information, data, and records under the products
            and services of [Haba] that you have logged in to and used with your account will be deleted or
            anonymized. You are also unable to retrieve, access, obtain, continue to use and recover and have no right
            to ask us to recover them (except as otherwise provided by laws and regulations or as otherwise required by
            regulatory authorities), including but not limited to:
        </p>
  
        <ur>
            <li>
                Personal information (such as profile picture and username and binding information (such as binding
                mobile phone number and email) under this account;
            </li>
        </ur>
        <ur>
            <li>
                Your personal information under this account (you are also no longer entitled to your user rights as
                set forth in the [Haba] Privacy Policy , except as otherwise provided by laws and regulations);
            </li>
        </ur>
        <ur>
            <li>
                All content (such as audio, pictures, photos, comments, interactions and likes) posted under this
                account;
            </li>
        </ur>
        <ur>
            <li>
                All other content, information, data and records.
            </li>
        </ur>
        <p>
            3.By applying for account cancellation, you accept to give up the rights and interests that have been
            generated but not fully consumed during the use of Haba products and services as well as the expected
            benefits in the future. That is, once your Haba account is canceled, we will clear all your rights and
            interests under this account, including:
        </p>
        <ur>
            <li>
                All your VIP membership rights, interests and levels that have not expired;
            </li>
        </ur>
        <ur>
            <li>
                Virtual currency and props purchased by recharging under your account;
            </li>
        </ur>
        <ur>
            <li>
                All your identity rights and interests in Haba products and/or services;
            </li>
        </ur>
        <p>
            4.Once your [Haba] account is canceled, it cannot be restored (even if you apply to us to register your
            [Haba] account again with the same mobile phone number or third-party account after the cancellation, the
            account will be a new one. Therefore, we kindly remind you to back up the contents you think need to be
            backed up in advance before applying for cancellation) ;
        </p>
        <p>
            5.Once your [Haba] account is canceled, the relevant user agreement and other rights and compulsory
            documents signed between you and us shall be terminated accordingly (except those which have been agreed to
            continue to take effect between you and us or otherwise stipulated by laws and regulations);
        </p>
        <p>
            6.Other results caused by [Haba] account cancellation.
        </p>
        <p>
            II.Before you apply to us for the cancellation of [Haba] account or are in the process of
            applying for the cancellation of [Haba] account, in order to protect your account security andproperty
            rights and interests, please check and ensure that the [Haba] account you have applied for the
            cancellation meets the following requirements, including:
        </p>
        <p>
            1.This account is registered by you through our official channels in accordance with the
            account is registered by you through our official channels in accordance with the <i>[Haba] Service
                Agreement</i> . and the specifications of the relevant platform;
        </p>
        <p>
            2.There is no fund in the account, including but not limited to:
        </p>
        <ur>
            <li>
                All the funds in the account, including diamonds/gold coins that have been consumed (or you voluntarily
                give up these rights and interests);
            </li>
        </ur>
        <ur>
            <li>
                No outstanding orders in the mall transaction;
            </li>
        </ur>
        <ur>
            <li>
                No other outstanding transactions or orders/services provided but unpaid.
            </li>
        </ur>
        <p>
            3.If the account has opened the "automatic renewal" function, please cancel "automatic renewal";
        </p>
        <p>
            4.Other content that needs to be satisfied in order to protect your account security and property rights and
            interests. You can first try to solve the above problems by yourself. If you fail to deal with them or have
            any doubts in the process, please contact [Haba] customer service staff for assistance.
        </p>
        <p>
            III.How to cancel your [Haba] account?
        </p>
        <p>
            1.You can initiate the process of account cancellation through [Me - Account Security - Delete Account].
            After you confirm to click "Delete Account" according to the process guidelines, your account will
            automatically enter a 15-day cooling-off period. During this period, you may terminate the account
            cancellation process by logging in again. If you do not log back in to your account, the platform will
            automatically complete the cancellation process after the cooling-off period expires. Please note that
            account cancellation is irreversible. Once the cooling-off period expires and the platform performs the
            cancellation, your data will not be recovered and all rights and interests under the account will be erased.
        </p>
        <p>
            2.This
            <i>[Haba] Account Cancellation Policy </i>
            contains the impact of account cancellation on your rights and interests and other contents. Please read
            carefully and fully understand it and proceed with the next step of cancellation after you accept all the
            contents of this
            <i>
                [Haba] Account Cancellation Policy
            </i>
        </p>
        <p>
            3.To protect your account security and property rights and interests, we need to authenticate your identity
            (for example, verify the mobile phone number or third-party account bound to this account) for cancellation
            application to ensure that this account is registered by you. For matters not covered in this policy, please
            refer to the
            <i>Haba] Service Agreement , [Haba] Privacy Policy,</i>
            as well as the rules and instructions related to the platform during the cancellation process. At the same
            time, you acknowledge and accept that: even if your [Haba] account is cancelled, it does not mitigate or
            exempt you from the relevant liabilities that you (may) need to assume in accordance with relevant laws and
            regulations, relevant agreements and rules.
            If you have any problems in the process of [Haba] account cancellation that you cannot handle or have any
            doubts in the process, please contact [Haba] customer service staff for assistance.
        </p>
        <p>
            Any dispute arising out of or in connection with this policy, including any issues relating to the
            existence, validity or termination of this policy, shall be handled in accordance with the terms of the
            <i>
                [Haba] Service Agreement
            </i>
        </p>



    </div>
</template>  

<script>
export default {
  name: "privacy",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.root{
    text-align: left;
    margin: 10px;
}
header{
    
    padding: 10px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
    font-weight: 900;
}
div {
    font-size: 25px;
    font-weight: 900;
}
b{
    font-size: 20px;
    font-weight: 900;
}

p{
    font-size: 16px;
    font-weight: 500;
}
table {
    border-collapse: collapse;
}

th, td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
}
td ,li{
    font-size: 16px;
}
a{
    color: blue;
}</style>
